// import { useQueryClient } from '@tanstack/react-query';
// import appointmentServices from '../services/appointment.service';

// export const usePrefetchAppointments = () => {
//   const queryClient = useQueryClient();

//   const prefetchNextPage = (filters, totalPages) => {
//     const nextPage = parseInt(filters.page) + 1;
//     if (nextPage <= totalPages) {
//       const nextFilters = { ...filters, page: nextPage };
//       queryClient.prefetchQuery({
//         queryKey: ['bookings', nextFilters.page, nextFilters.limit, nextFilters.status, nextFilters.bookingType, nextFilters.paymentStatus, nextFilters.customerId, nextFilters.sellerId, nextFilters.serviceId, nextFilters.assignedStaffId, nextFilters.startDate, nextFilters.endDate, nextFilters.search, nextFilters.sortBy, nextFilters.sortOrder],
//         queryFn: () => appointmentServices.getBookings(nextFilters),
//         staleTime: 30 * 1000,
//       });
//     }
//   };

//   const prefetchBooking = (bookingId) => {
//     queryClient.prefetchQuery({
//       queryKey: ['booking', bookingId],
//       queryFn: () => appointmentServices.getBookingById(bookingId),
//       staleTime: 30 * 1000,
//     });
//   };

//   return { prefetchNextPage, prefetchBooking };
// };



import { useQueryClient } from '@tanstack/react-query';
import appointmentServices from '../services/appointment.service';

export const usePrefetchAppointments = () => {
  const queryClient = useQueryClient();

  const prefetchNextPage = (filters, totalPages) => {
    const nextPage = parseInt(filters.page) + 1;

    if (nextPage <= totalPages) {
      const nextFilters = { ...filters, page: nextPage };

      queryClient.prefetchQuery({
        queryKey: [
          'appointments',
          nextFilters.page,
          nextFilters.limit,
          nextFilters.status,
          nextFilters.type,
          nextFilters.startDate,
          nextFilters.endDate,
          nextFilters.search,
        ],
        queryFn: () =>
          appointmentServices.getAppointments(nextFilters),
        staleTime: 30 * 1000,
      });
    }
  };

  const prefetchAppointment = (id) => {
    queryClient.prefetchQuery({
      queryKey: ['appointment', id],
      queryFn: () =>
        appointmentServices.getAppointmentById(id),
      staleTime: 30 * 1000,
    });
  };

  return { prefetchNextPage, prefetchAppointment };
};